<template>
  <div class="row input-section message-form">
    <div class="col-md-12 col-lg-12 col-sm-12">
      <div class="row p-0">
        <!-- Breadcrumbs -->
        <nav aria-label="breadcrumb" class="col-md-6 col-lg-6 col-sm-6 pt-4" style="padding-left: unset;">
          <ol class="breadcrumb align-middle">
            <li class="breadcrumb-item">
              <a :href="'/networks/' + network.slug + '/messages'" class="text-primary fw-bold">
                {{ $t('announcements') }}
              </a>
            </li>
            <li class="breadcrumb-item">
              <a class="text-secondary fw-bold">
                <span v-if="path[4] == 'create'">{{ $t('network.messages.CreateMessage') }}</span>
                <span v-else>{{ $t('network.messages.UpdateMessage') }}</span>
              </a>
            </li>
          </ol>
        </nav>
        <div class="col-md-6 col-lg-6 col-sm-6 pt-4">
          <div class="form-check form-switch float-end">
            <input id="mail_from" v-model="mail_setting" data-test="mail_from" type="checkbox" class="form-check-input" />
            <label for="mail_from" class="form-check-label form-check-lg">{{ $t('network.message.modify-mail-setting') }}</label>
          </div>
        </div>
      </div>
    </div>
    <ValidationError v-if="messageFormErrors" :errors="messageFormErrors"></ValidationError>
    <div class="col-md-12 col-lg-12 col-sm-12">
      <!--Mail Setting start-->
      <div v-if="mail_setting" class="form-group py-2">
        <label for="mail_from_text">{{ $t('NetworkMessageForm.from') }}</label>
        <input id="mail_from_text" v-model="form.mail_from_text" data-test="mail_from_text" type="text" class="form-control" />
      </div>
      <div v-if="mail_setting" class="form-group py-2">
        <label for="mailTo">{{ $t('NetworkMessageForm.mail-to') }}</label>
        <button id="mailTo" data-test="mailTo" type="button" class="btn btn-primary btn-sm ms-3">
          {{ this.network.name }} : {{ $t('network.tabMembers') }}
          <span class="badge bg-light ms-1">{{ this.network.members_count }}</span>
        </button>
      </div>
      <!--Mail Setting end-->
      <div class="row">
        <div class="col-md-8 ps-0">
          <div class="form-group py-2">
            <label for="title" class="fw-bold">{{ $t('network.networkForm.title') }}</label>
            <input id="title" v-model="form.title" data-test="title" type="text" :placeholder="$t('enter-title-for-your-message')" class="custom-input form-control" autofocus />
          </div>
        </div>
        <div class="col-md-4 pe-0">
          <div class="form-group py-2">
            <label class="fw-bold"></label>
            <div class="form-check pt-2" style="display: flex; justify-content: space-between;">
              <div v-for="(editor, index) in editors" :key="index" class="form-check-inline">
                <input
                  :id="editor.id"
                  v-model="form.type"
                  :data-test="editor.id"
                  type="radio"
                  :value="editor.value"
                  class="form-check-input check-input"
                  @click.prevent="onEditorChange(editor.value)"
                />
                <span class="check-span">{{ editor.label }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div v-if="iftinyEditor" class="col-md-8 ps-0">
          <div class="form-group py-2">
            <label class="fw-bold">{{ $t('insert') }}</label>
            <v-select
              v-model="selectedVariable"
              :options="variableOptions"
              label="label"
              :placeholder="$t('select-option-to-insert')"
              @input="handleVariableClick"
            ></v-select>
          </div>
        </div>
        <div v-if="ifunlayerEditor && templateOptions.length > 0" class="col-md-8 ps-0">
          <div class="form-group py-2">
            <label class="fw-bold">{{ $t('network.messages.availableTemplates') }}</label>
            <ul type="none" class="p-0">
              <li>
                <label
                  v-for="(option, index) in templateOptions"
                  :key="index"
                  role="button"
                  class="m-2 p-2 badge bg-info btn-block"
                  @click="setTemplateToMessage(option.template)"
                >
                  {{ option.name }}
                </label>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="card shadow-lg p-2 mt-3">
        <div class="d-flex justify-content-between">
          <label class="fw-bold">{{ $t('network.member.message') }}</label>
          <label v-if="path[4] != 'create' && message && message.history.length" class="fw-bold text-primary cursor" @click="showMessageEditHistoryModal = ! showMessageEditHistoryModal">
            View edit history
          </label>
        </div>
        <EmailEditor v-if="ifunlayerEditor" ref="emailEditor" v-model="form.design" style="height: 700px; width: 100%;" @ready="unlayerEditorReady" />
        <editor
          v-if="iftinyEditor"
          v-model="form.content"
          :api-key="tinyMceApiKey"
          :init="{
            height: 500,
            menubar: false,
            images_upload_handler: uploadImageTinyMceBlob,
            automatic_uploads: true,
            file_picker_types: 'image',
            browser_spellcheck: true,
            paste_as_text: true,
            relative_urls : false,
            remove_script_host : false,
            document_base_url : home,
            plugins: [
              'advlist autolink lists link image charmap print preview anchor',
              'searchreplace visualblocks code fullscreen',
              'insertdatetime media table paste code help wordcount',
            ],
            toolbar:
              'undo redo | formatselect | bold italic backcolor | \
             alignleft aligncenter alignright alignjustify | \
             bullist numlist outdent indent | removeformat | help | link image ',
            image_advtab: true,
            image_class_list: [
              { title: 'None', value: '' },
              { title: 'Rounded', value: 'rounded' },
              { title: 'Rounded (circle)', value: 'rounded-circle' },
              { title: 'Margin Right', value: 'mr-5' },
              { title: 'Picture', value: 'img-fluid img-thumbnail' },
              { title: 'Fluid', value: 'img-fluid' },
            ],
          }"
        />

        <br><label class="fw-bold">{{ $t('attach-existing-media') }}</label>
        <NetworkMediaSelector :network="network" :existingMedia="existingMedia" @media-selected="mediaSelectedEvent" />
      </div>

      <div class="card shadow-lg p-2 my-3">
        <label class="fw-bold">{{ $t('choose-when-to-send') }}</label>
        <div class="can-toggle can-toggle--size-large">
          <input id="c" v-model="form.schedule_message" type="checkbox">
          <label data-test="choose_when_send" for="c">
            <div class="can-toggle__switch pointer" data-checked="Later" data-unchecked="Now"></div>
          </label>
        </div>

        <div v-if="form.schedule_message">
          <div class="d-flex justify-content-between mt-3">
            <div class="col-6 pe-2">
              <label class="fw-bold">{{ $t('network.date') }}</label><br>
              <date-picker
                v-model="form.sent_at_date"
                value-type="format"
                format="YYYY-MM-DD"
                type="date"
                data-test="date"
                :placeholder="$t('network.dashboard.selectDate')"
                style="width: -webkit-fill-available;"
              ></date-picker>
            </div>
            <div class="col-6 ps-2">
              <label class="fw-bold">{{ $t('network.meeting.time') }}</label><br>
              <date-picker
                v-model="form.sent_at_time"
                value-type="format"
                format="HH:mm"
                type="time"
                :placeholder="$t('select-time')"
                style="width: -webkit-fill-available;"
              ></date-picker>
            </div>
          </div>

          <br><label class="fw-bold">{{ $t('change-timezone') }}</label>
          <div class="form-group">
            <v-select
              id="timezones"
              v-model="form.timezone"
              data-test="timezones"
              :options="timezones"
              label="name"
              :clearable="false"
              :placeholder="$t('network.meeting.selectTimezone')"
            ></v-select>
          </div>
        </div>
      </div>

      <span id="message-preview" data-test="message-preview" class="text-primary fw-bold pointer" @click="message_preview = !message_preview, showMessagePreview()">
        {{ $t('see-preview') }}
      </span>
    </div>

    <div class="col-md-12 col-lg-12 col-sm-12 mt-4">
      <button id="save" data-test="save" :disabled="iftinyEditor ? (form.title.length === 0 || form.content.length === 0) : form.title.length === 0"
       class="btn btn-outline-primary me-2" style="border: 2px solid;" @click="submitRequest('save')">
        {{ $t('finish-later') }}
      </button>
      <button id="send" data-test="send" :disabled="iftinyEditor ? (form.title.length === 0 || form.content.length === 0) : form.title.length === 0"
      class="btn btn-primary" @click="submitRequest('send')">
        <div v-if="form.schedule_message">{{ $t('schedule') }}</div>
        <div v-else>{{ $t('send-now') }}</div>
      </button>
    </div>

    <b-modal
      v-if="iftinyEditor"
      id="messagePreviewModal"
      size="lg"
      hide-footer
      :title="this.$t('network.messages.networkMessagePreview')"
      body-class="p-0"
      @hide="message_preview = false"
    >
      <p v-html="message_preview_html"></p>
    </b-modal>
    <b-modal v-model="upcomingMeetings" hide-footer hide-header size="lg">
      <v-select
        id="upcoming_meetings"
        data-test="upcoming_meetings"
        :options="upcoming_meetings"
        placeholder="Select meeting to include"
        label="title"
        @input="addMeeting"
      >
      <template v-slot:option="option">
        {{ utcToLocal(option.start).format('dddd, MMMM D, YYYY, hh:mm A') }} - <b>{{ option.title }}</b>
      </template>
      <template v-slot:no-options>{{ $t('sorry-there-are-no-upcoming-meetings-for-this-network') }}</template>
      </v-select>
    </b-modal>
    <b-modal v-model="upcomingMeetingsCalendar" hide-footer hide-header size="lg">
      <v-select
        id="upcoming_meetings_calendar"
        data-test="upcoming_meetings_calendar"
        :options="upcoming_meetings"
        placeholder="Select meeting to add to calendar"
        label="title"
        @input="addMeetingToCalendar"
      >
      <template v-slot:option="option">
        {{ utcToLocal(option.start).format('dddd, MMMM D, YYYY, hh:mm A') }} - <b>{{ option.title }}</b>
      </template>
      <template v-slot:no-options>{{ $t('sorry-there-are-no-upcoming-meetings-for-this-network') }}</template>
      </v-select>
    </b-modal>
    <b-modal v-model="showMessageEditHistoryModal" hide-footer hide-header size="sm" @close="showMessageEditHistoryModal = false">
      <h3 style="margin-left: 35px;">Edit history</h3>
      <div v-if="message && message.history">
        <ul class="timeline">
          <li v-for="editor in this.message.history" :key="editor">
            <div class="direction-r">
              <div class="flag-wrapper">
                <span class="flag">{{ momentShortenedFormat(editor.date) }}</span>
              </div>
              <div class="desc">Updated by {{ editor.name }}</div>
            </div>
          </li>
        </ul>
      </div>
    </b-modal>
  </div>
</template>
<script>
import NetworkMediaSelector from '@/components/commons/Media/Selector.vue';
import ValidationError from '../../../components/forms/ValidationError.vue';
import { EmailEditor } from 'vue-email-editor';
import { loadProgressBar } from 'axios-progress-bar';
import axios from 'axios';
import copy from 'copy-to-clipboard';
//import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import Editor from '@tinymce/tinymce-vue';
import moment from 'moment';
import { orderBy, split } from 'lodash';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

export default {
  components: {
    NetworkMediaSelector,
    ValidationError,
    //DateRangePicker,
    DatePicker,
    Editor,
    EmailEditor,
    vSelect,
  },
  props: {
    network: {
      type: Object,
      default: null,
    },
    message: {
      type: Object,
      default: null,
    },
    reusedContent: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      tinyMceApiKey: process.env.VUE_APP_TINYMCE_API_KEY,
      editors: [
        { id: 'unlayer', value: 'unlayer', label: this.$t('NetworkMessageForm.unlayer-builder') },
        { id: 'tinymceEditor', value: 'tinymce', label: 'TinyMCE' },
      ],
      wantToAttachMedia: false,
      form: this.initialForm(),
      files: [],
      timezones: [],
      s3Params: {},
      options: {}, // uploader options
      uploadFinished: false,
      minDate: new Date(),
      maxDate: new Date(),
      message_preview: false,
      message_preview_html: '',
      existingMedia: null,
      formType: this.message ? 'edit' : 'create',
      templateOptions: this.getTemplates(),
      messageFormErrors: [],
      mail_setting: false,
      upcomingMeetings: false,
      upcomingMeetingsCalendar: false,
      upcoming_meetings: [],
      home: window.location.origin,
      path: split(this.$route.fullPath, '/'),
      selectedVariable: null,
      variableOptions: [
        { label: this.$t('network.auth.firstName'), value: '{{FIRST_NAME}}', clickHandler: 'copyVariable' },
        { label: this.$t('network.auth.lastName'), value: '{{LAST_NAME}}', clickHandler: 'copyVariable' },
        { label: this.$t('network.auth.email'), value: '{{EMAIL}}', clickHandler: 'copyVariable' },
        { label: this.$t('network.message.attachedMedia'), value: '{{ATTACHED_MEDIA}}', clickHandler: 'copyVariable' },
        { label: this.$t('network.meeting.joinMeeting'), value: '{{JOIN_MEETING}}', clickHandler: 'toggleMeetings' },
        ...(this.network.vanity_link
        ? [
            { label: 'Vanity Link', value: this.network.vanity_link, clickHandler: 'addVanityLink' },
          ]
        : []),
        { label: this.$t('add-to-calendar'), value: '{{ADD_TO_CALENDAR}}', clickHandler: 'toggleMeetings' },
      ],
      customTimezone: false,
      showMessageEditHistoryModal: false,
    };
  },
  computed: {
    iftinyEditor() {
      return this.form.type === 'tinymce';
    },
    ifunlayerEditor() {
      return this.form.type === 'unlayer';
    },
    formErrors() {
      return this.$store.state.validationErrors;
    },
    formUpdated(){
      return ( JSON.stringify(this.form) != JSON.stringify(this.initialForm()) ) ? true : false;
    }
  },
  watch: {
    formUpdated(value) {
        this.$emit('form-updated', value);
    }
  },
  mounted() {
    this.init();
    if (this.message) {
      this.form = this.editData();
    }
  },
  methods: {
    /**
     * @define called when the editor has finished loading
     */
    unlayerEditorReady() {
      this.$refs.emailEditor.editor.registerCallback('image', (file, done) => {
        // CAUTION only handles a single upload
        window.file = file;
        this.uploadImage(file.attachments[0], done, 'unlayer');
      });

      if (this.formType === 'edit' && this.message.type === 'unlayer') {
        var loadDesign = this.message.design.design;
        if (loadDesign) {
          this.$refs.emailEditor.editor.loadDesign(loadDesign);
        }
      }
    },
    handleVariableClick(variable) {
      const clickHandler = this[variable.clickHandler];
      if (clickHandler) {
        clickHandler(variable.value);
      }
    },
    copyVariable(variable) {
      copy(variable);
      this.form.content = this.form.content + variable;
      let msg = this.$t('network.message.textCopied');
      this.showToast(msg, this.$t('network.message.textCopied'), 'info', false);
    },
    addMeeting(meeting){
      if (!meeting) return;
      this.copyVariable('<a href="https://networks.resonancehealth.org/networks/join-meeting/' + meeting.id + '" target="_blank">'+
      '<button style="background-color: #3498db; border-color: #3498db; border: solid 1px #3498db; border-radius: 5px; box-sizing: border-box; color: #ffffff; cursor: pointer; display: inline-block; font-size: 14px; font-weight: bold; margin: 0; padding: 12px 25px; text-decoration: none; width: 150px;">'+
      'Join Meeting</button></a>'+' ');
    },
    addMeetingToCalendar(meeting){
      if (!meeting) return;
      this.copyVariable('<a href="https://networks.resonancehealth.org/networks/join-meeting/' + meeting.id + '" target="_blank">'+
      '<button style="background-color: #3498db; border-color: #3498db; border: solid 1px #3498db; border-radius: 5px; box-sizing: border-box; color: #ffffff; cursor: pointer; display: inline-block; font-size: 14px; font-weight: bold; margin: 0; padding: 12px 25px; text-decoration: none; width: 175px;">'+
      'Add to Calendar</button></a>'+' ');
    },
    addVanityLink(link){
      if (!link) return;
      this.copyVariable('<a href="' + link + '" target="_blank">'+
      '<button style="background-color: #3498db; border-color: #3498db; border: solid 1px #3498db; border-radius: 5px; box-sizing: border-box; color: #ffffff; cursor: pointer; display: inline-block; font-size: 14px; font-weight: bold; margin: 0; padding: 12px 25px; text-decoration: none; width: 150px;">'+
      'Join Meeting</button></a>'+' ');
    },
    toggleMeetings(value) {
      if (value == '{{JOIN_MEETING}}') {
        this.upcomingMeetings = !this.upcomingMeetings;
      } else {
        this.upcomingMeetingsCalendar = !this.upcomingMeetingsCalendar;
      }
    },
    utcToLocal: function (dt) {
      return moment.utc(dt).local();
    },
    momentFormat: function (dt) {
      return moment(dt);
    },
    momentShortenedFormat: function (dt) {
      return moment.utc(dt, "MMMM D, YYYY, h:mm a").local().format("MMM D, YYYY, h:mm a");
    },
    /**
     * @define Form events
     */
    init() {
      //this.maxDate.setDate(new Date().getDate() + 5);
      this.maxDate.setDate(new Date());
      this.busy = true;

      this.$http
        .post('s3/upload-params')
        .then(resp => {
          this.setupUploadForm(resp.data);
          // upload seutp is done!
          this.busy = false;
        })
        .catch(err => {
          this.$bvModal.msgBoxOk(
            this.$t('CreateMediaWithoutCollection.s3-upload-initialization-failed-please-check-console-for-details-or-refresh-the-page-to-try-again')
          );
          console.log('get s3 upload params failed', err);
          this.busy = false;
        });

      this.$http.get('networks/' + this.network.slug + '/meetings').then(resp => {
        let meetings = [];
        // future meetings
        resp.data.upcomingWithOccurrences.forEach(m => meetings.push(m));
        // in progress meetings
        resp.data.inProgressWithOccurrences.forEach(m => meetings.push(m));
        this.upcoming_meetings = orderBy(meetings, 'start');
      });

      this.$http.get('timezones').then(resp => {
        this.timezones = resp.data;
        let browserTZ = Intl.DateTimeFormat().resolvedOptions().timeZone;
        if (browserTZ == 'America/Buenos_Aires') {
          browserTZ = 'America/Argentina/Buenos_Aires';
        }
        this.form.timezone = resp.data.find(tz => tz.name == browserTZ);
        this.form.local_timezone = resp.data.find(tz => tz.name == browserTZ);
        if (!this.form.timezone) {
          /*this.$swal.fire({
            icon: 'info',
            title: this.$t('user.timezone.notFound', {
              defaultValue: 'We were unable to match your timezone ({{timezone}}), please select it from the list.',
              timezone: browserTZ,
            }),
          });*/
          this.form.timezone = resp.data.find(tz => tz.name == 'UTC');
          this.form.local_timezone = resp.data.find(tz => tz.name == 'UTC');
        }
      });
    },
    setupUploadForm(s3) {
      // see option documentation here: https://github.com/thetutlage/vue-clip
      this.options = {
        url: s3.formAttributes.action,
        maxFilesize: this.maxFilesize || 500, // 500 MB
        autoProcessQueue: true,
        maxFiles: this.maxFiles || 10,
      };
      if (this.acceptedFiles) this.options.acceptedFiles = this.acceptedFiles;

      this.s3Params = s3;
    },
    initialForm() {
      return {
        title: '',
        content: this.reusedContent ?? '',
        timezone: '',
        local_timezone: '',
        design: '',
        type: 'tinymce',
        attached_media_id: null,
        sent_at_date: moment().add(1, 'hour').format('YYYY-MM-DD'),
        sent_at_time: moment().add(1, 'hour').format('HH:mm'),
        schedule_message: false,
        mail_from_text: this.network.default_from_name,
      };
    },
    editData() {
      let $message = this.message;
      let sent_at_date = $message.is_scheduled
        ? moment(this.utcToLocal($message.scheduled_on)).format('YYYY-MM-DD')
        : '';
      let sent_at_time = $message.is_scheduled
        ? moment(this.utcToLocal($message.scheduled_on)).format('HH:mm')
        : '';
      this.wantToAttachMedia = !!$message.attached_media_id;
      this.existingMedia = this.wantToAttachMedia ? $message.media : null;
      return {
        title: $message.title,
        content: $message.content,
        timezone: $message.timezone,
        local_timezone: $message.local_timezone,
        design: [],
        type: $message.type,
        attached_media_id: $message.attached_media_id,
        sent_at_date,
        sent_at_time,
        schedule_message: !!$message.is_scheduled,
      };
    },
    mediaSelectedEvent(media) {
      this.form.attached_media_id = media.id;
    },
    /**
     * @define To submit form
     */
    submitRequest(requestAction) {
      this.$emit('form-updated', false);
      let msg, url, message;
      let isSave = requestAction === 'save';
      this.form.eventAction = isSave ? 'save' : 'send';
      this.form.schedule_message =
        this.form.schedule_message === null || this.form.schedule_message === '' || this.form.schedule_message === false ? false : true;
      if (this.form.schedule_message) {
        message = this.$t('network.messages.areYouSureSchedule');
      } else {
        message = this.$t('network.messages.areYouSure');
      }
      msg = !isSave ? message : '';
      url = this.message ? 'networks/messages/' + this.message.id : 'networks/' + this.network.slug + '/messages';
      this.form._method = this.formType === 'edit' ? 'PUT' : 'POST';
      this.form.local_timezone = this.form.timezone;
      if (this.ifunlayerEditor) {
        this.$refs.emailEditor.editor.exportHtml(data => {
          this.form.design = data;
          this.sendMessageAction(isSave, url, msg);
        });
      } else {
        this.sendMessageAction(isSave, url, msg);
      }
    },
    sendMessageAction(isSave, url, msg) {
      if (!isSave) {
        let action = () => {
          this.$http
            .post(url, this.form)
            .then(() => {
              if (this.form.schedule_message) {
                this.wantToAttachMedia = false;
                this.form = this.initialForm();
                window.location.href = '/networks/' + this.network.slug + '/messages#scheduled';
              } else {
                this.wantToAttachMedia = false;
                this.form = this.initialForm();
                window.location.href = '/networks/' + this.network.slug + '/messages#sent';
              }
            })
            .catch(error => {
              this.showServerError(error);
            });
        };
        this.showConfirmPrompt(action, msg);
      } else {
        this.$http
          .post(url, this.form)
          .then(() => {
            this.wantToAttachMedia = false;
            window.location.href = '/networks/' + this.network.slug + '/messages#drafts';
          })
          .catch(error => {
            this.showServerError(error);
          });
      }
    },
    /**
     * @define Upload To S3 function for TinyMCE and Unlayer
     */
    async uploadImageTinyMceBlob(blobInfo, success) {
      await this.uploadImage(blobInfo.blob(), success, 'tinymce');
    },
    /**
     * @define Upload Image to S3 using Axios
     * @param file
     * @param success
     * @param requestType
     * @returns {Promise<void>}
     */
    async uploadImage(file, success, requestType) {
      let remoteHost = this.s3Params.formAttributes.action;
      var fullPath = file.name;
      var properPath = this.s3Params.uploadPathPrefix + '/' + fullPath;

      var formData = new FormData();
      // update formData before the file is uploaded
      for (let key in this.s3Params.formInputs) {
        var value = this.s3Params.formInputs[key];
        if (key == 'key') value = properPath; // use the proper path calculated (in case its a full folder upload)
        formData.append(key, value);
      }
      this.files.push({
        name: file.name,
        size: file.size,
        fullPath: properPath,
      });
      formData.append('file', file, file.name);
      let axios_instance = axios.create({ headers: { Authorization: '' } });
      loadProgressBar('', axios_instance);
      await axios_instance
        .post(remoteHost, formData)
        .then(() => {
          let attributes = {
            url: remoteHost + '/' + properPath,
            href: remoteHost + '/' + properPath,
          };
          if (requestType === 'tinymce') {
            success(attributes.url);
          } else {
            success({ url: attributes.url });
          }
        })
        .catch(err => {
          console.log('get s3 upload params failed', err);
        });
    },
    /**
     * @define To Load Network Template for Unlayer Editor
     */
    getTemplates() {
      this.$http.get('networks/' + this.network.slug + '/templates').then(res => {
        this.templateOptions = res.data;
      });
    },
    /**
     * @define To Set Template design in Editor by Selecting Template Option
     * @param template
     */
    setTemplateToMessage(template) {
      this.$refs.emailEditor.editor.loadDesign(template.design);
    },
    /**
     * @define To show preview of Email template in modal
     */
    showMessagePreview() {
      this.form.eventAction = 'preview';
      this.$http.post('networks/' + this.network.slug + '/message/preview', this.form).then(res => {
        this.message_preview_html = res.data;

        if (this.message_preview) {
          this.$bvModal.show('messagePreviewModal');
        } else {
          this.$bvModal.hide('messagePreviewModal');
        }
      });
    },
    /**
     * @define To Change Editor Layout
     * @param value
     */
    onEditorChange(value) {
      let msg =
        this.$t('NetworkMessageForm.are-you-sure-you-want-to-change-editor') + ' ' + this.$t('NetworkMessageForm.you-will-lose-all-changes-you-made-since-last-save');
      let action = () => {
        this.form.type = value;
      };
      this.showConfirmPrompt(action, msg);
    },
    /**
     * @define show server error with alert
     */
    showServerError(error) {
      let statusCodes = [403, 404, 422];
      if (!statusCodes.includes(error.response.status)) {
        this.messageFormErrors = [JSON.parse(error.request.response).message];
      }
    },
  },
};
</script>
<style scoped>
.message-variable {
  cursor: pointer;
}
.check-span {
  vertical-align: sub !important;
  margin-left: 10px !important;
}
.check-input {
  width: 1.5em !important;
  height: 1.5em !important;
}
.custom-input {
  background-color: #fff;
  border-color: rgb(195 174 174 / 26%);
  box-shadow: 0 0 0 0 transparent, 0 0.375rem 0.625rem -0.3125rem rgba(0, 95, 154, 0.15);
}
/* switch */
.can-toggle {
  position: relative;
  font-weight: 700;
}
.can-toggle *, .can-toggle *:before, .can-toggle *:after {
  box-sizing: border-box;
}
.can-toggle input[type=checkbox] {
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
}
.can-toggle input[type=checkbox][disabled] ~ label {
  pointer-events: none;
}
.can-toggle input[type=checkbox][disabled] ~ label .can-toggle__switch {
  opacity: 0.4;
}
.can-toggle input[type=checkbox]:checked ~ label .can-toggle__switch:before {
  content: attr(data-unchecked);
  left: 0;
}
.can-toggle input[type=checkbox]:checked ~ label .can-toggle__switch:after {
  content: attr(data-checked);
}
.can-toggle label {
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
  position: relative;
  display: flex;
  align-items: center;
}
.can-toggle label .can-toggle__switch {
  position: relative;
}
.can-toggle label .can-toggle__switch:before {
  content: attr(data-checked);
  position: absolute;
  top: 0;
  text-transform: uppercase;
  text-align: center;
}
.can-toggle label .can-toggle__switch:after {
  content: attr(data-unchecked);
  position: absolute;
  z-index: 5;
  text-transform: uppercase;
  text-align: center;
  background: #F1FAFF;
  transform: translate3d(0, 0, 0);
}
.can-toggle input[type=checkbox][disabled] ~ label {
  color: rgba(119, 119, 119, 0.5);
}
.can-toggle input[type=checkbox]:focus ~ label .can-toggle__switch, .can-toggle input[type=checkbox]:hover ~ label .can-toggle__switch {
  background-color: #D9D9D9;
}
.can-toggle input[type=checkbox]:focus ~ label .can-toggle__switch:after, .can-toggle input[type=checkbox]:hover ~ label .can-toggle__switch:after {
  color: #5c6d80;
}
.can-toggle input[type=checkbox]:hover ~ label {
  color: #5c6d80;
}
.can-toggle input[type=checkbox]:checked ~ label:hover {
  color: #5c6d80;
}
.can-toggle input[type=checkbox]:checked ~ label .can-toggle__switch {
  background-color: #D9D9D9;
}
.can-toggle input[type=checkbox]:checked ~ label .can-toggle__switch:after {
  color: #5c6d80;
}
.can-toggle input[type=checkbox]:checked:focus ~ label .can-toggle__switch, .can-toggle input[type=checkbox]:checked:hover ~ label .can-toggle__switch {
  background-color: #D9D9D9;
}
.can-toggle input[type=checkbox]:checked:focus ~ label .can-toggle__switch:after, .can-toggle input[type=checkbox]:checked:hover ~ label .can-toggle__switch:after {
  color: #5c6d80;
}
.can-toggle label .can-toggle__switch {
  transition: background-color 0.3s cubic-bezier(0, 1, 0.5, 1);
  background: #D9D9D9;
}
.can-toggle label .can-toggle__switch:before {
  color: #5c6d80;
}
.can-toggle label .can-toggle__switch:after {
  transition: transform 0.3s cubic-bezier(0, 1, 0.5, 1);
  color: #5c6d80;
}
.can-toggle input[type=checkbox]:checked ~ label .can-toggle__switch:after {
  transform: translate3d(157px, 0, 0);
}
.can-toggle label {
  font-size: 14px;
}
.can-toggle label .can-toggle__switch {
  height: 36px;
  flex: 0 0 134px;
}
.can-toggle.can-toggle--size-large label {
  font-size: 14px;
}
.can-toggle.can-toggle--size-large label .can-toggle__switch {
  height: 52px;
  flex: 0 0 320px;
  border-radius: 1rem;
}
.can-toggle.can-toggle--size-large label .can-toggle__switch:before {
  left: 160px;
  font-size: 14px;
  line-height: 50px;
  width: 160px;
  padding: 0 12px;
  border-radius: 1rem;
}
.can-toggle.can-toggle--size-large label .can-toggle__switch:after {
  top: 3px;
  left: 3px;
  width: 156px;
  line-height: 46px;
  font-size: 14px;
  border-radius: 1rem;
}
/*edit history*/
.timeline {
  margin: 0 auto;
  margin-top: 15px;
  list-style-type: none;
}
.timeline:before {
  position: absolute;
  left: 9%;
  top: 0;
  content: ' ';
  display: block;
  width: 3px;
  height: 100%;
  margin-left: -3px;
  background: rgb(80,80,80);
  z-index: 5;
}
.timeline li {
  padding: 1em 0;
}
.timeline li:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.direction-r {
  position: relative;
  width: 220px;
  float: right;
}
.flag-wrapper {
  position: relative;
  display: inline-block;
  text-align: center;
}
.flag {
  position: relative;
  display: inline;
  border-radius: 5px;
  font-size: larger;
  font-weight: 600;
  text-align: left;
}
.direction-r .flag:before {
  position: absolute;
  top: 50%;
  right: -40px;
  content: ' ';
  display: block;
  width: 15px;
  height: 15px;
  margin-top: -10px;
  background: rgb(80, 80, 80);
  border-radius: 10px;
  border: 4px solid rgb(80, 80, 80);
  z-index: 10;
  left: -40px;
}
.direction-r .flag:after {
  content: "";
  position: absolute;
  right: 100%;
  top: 50%;
  height: 0;
  width: 0;
  margin-top: -8px;
  border: solid transparent;
  border-right-color: rgb(248,248,248);
  border-width: 8px;
  pointer-events: none;
}
.desc {
  font-size: large;
  font-weight: 600;
  line-height: 1.5em;
}
</style>
<style>
.mx-table {
  width: initial !important;
}
</style>